import { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomColorProps = {
  body?: boolean
  invertedBody?: boolean
  invertedMuted?: boolean
  invertedTitle?: boolean
  linkColor?: boolean
  muted?: boolean
  title?: boolean
}

const bodyCss = ({ body }: CustomColorProps) =>
  body &&
  css`
    color: ${themeGet('colors.text.body')};
  `

const invertedBodyCss = ({ invertedBody }: CustomColorProps) =>
  invertedBody &&
  css`
    color: ${themeGet('colors.text.invertedBody')};
  `

const linkColorCss = ({ linkColor }: CustomColorProps) =>
  linkColor &&
  css`
    color: ${themeGet('colors.text.link')};
  `

const invertedMutedCss = ({ invertedMuted }: CustomColorProps) =>
  invertedMuted &&
  css`
    color: ${themeGet('colors.text.invertedMuted')};
  `

const invertedTitleCss = ({ invertedTitle }: CustomColorProps) =>
  invertedTitle &&
  css`
    color: ${themeGet('colors.text.invertedTitle')};
  `

const mutedCss = ({ muted }: CustomColorProps) =>
  muted &&
  css`
    color: ${themeGet('colors.text.muted')};
  `

const titleCss = ({ title }: CustomColorProps) =>
  title &&
  css`
    color: ${themeGet('colors.text.title')};
  `

export type { CustomColorProps }
export {
  bodyCss,
  invertedBodyCss,
  invertedMutedCss,
  invertedTitleCss,
  linkColorCss,
  mutedCss,
  titleCss,
}
